module.exports = __webpack_public_path__ + "b271666bca36a637e30592661dfa280b.png";